module.exports = __webpack_public_path__ + "static/media/08_tn.31566fcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/08_tn.jpg
// module id = 146
// module chunks = 0